var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _vm.canApproveTermsAndConditions
        ? _c("booking-alert-terms-and-conditions")
        : _vm._e(),
      _vm._v(" "),
      _vm._l(_vm.bookingAttendingTalent, function (user) {
        return _vm.canConfirmTalentAttendance
          ? _c("booking-alert-talent-attendance-confirmation", {
              key: `attending-${user.id}`,
              attrs: { user: user },
            })
          : _vm._e()
      }),
      _vm._v(" "),
      _vm._l(_vm.bookingAttendingTalent, function (user) {
        return _vm.canMarkCompleted
          ? _c("booking-alert-mark-talent-completed", {
              key: `complete-${user.id}`,
              attrs: { user: user },
            })
          : _vm._e()
      }),
      _vm._v(" "),
      _vm.$userIsAdmin && _vm.canMarkCompleted
        ? _c("booking-alert-admin-mark-completed")
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }